import { baseUniDriverFactory } from '../utils/test-utils/unidriver';

// Embla carousel doesn't duplicate slides like react-slick, so we can use simpler selectors
const slideSelector = '.embla__slide';

export interface CarouselUniDriver {
  exists: () => Promise<boolean>;
  /**
   * Checks whether the carousel is loading
   * @return {Promise<boolean>}
   */
  isLoading: () => Promise<boolean>;

  /**
   * Gets children list elements
   * @return {UniDriverList}
   */
  getChildren: () => any;

  /**
   * Get a list of the carousel images
   * @return {Promise<Array<string | null>>}
   */
  getImages: () => Promise<Array<string | null>>;

  /**
   * Click on the previous item button
   * @return {Promise<void>}
   */
  clickPrevious: () => Promise<void>;

  /**
   * Click on the next item button
   * @return {Promise<void>}
   */
  clickNext: () => Promise<void>;
}

export const carouselUniDriverFactory = (base: any): CarouselUniDriver => {
  return {
    ...baseUniDriverFactory(base),

    isLoading: async () => (await base.$$('[data-hook="loader"]').count()) > 0,
    getChildren: () => base.$$(slideSelector).map((child: any) => child),
    getImages: () =>
      base
        .$$(slideSelector + ' [data-hook="carousel-img"]')
        .map((img: any) => img.attr('src')),
    clickPrevious: () => base.$('[data-hook="prev-button-element"]').click(),
    clickNext: () => base.$('[data-hook="next-button-element"]').click(),
  };
};
